export default {
  route: {
    Student: 'Student Management',
    StudentList: 'Student List'
  },
  '学生管理': 'Student Management',
  '学生列表': 'Student List',
  '添加学生': 'Add Student',
  '请输入学生姓名或学号': 'Enter student name or student number',
  '请输入学生姓名、手机号或留言详情': 'Enter student name, phone number or message detail',
  '删除选中': 'Delete selected',
  '状态': 'Status',
  '搜索': 'Search',
  '清空': 'Clear',
  '启用': 'Enable',
  '禁用': 'Disable',
  '操作': 'Action',
  '详情': 'Detail',
  '删除': 'Delete',
  '学生详情': 'Student Detail',

  'ID': 'ID',
  '姓名': 'Name',
  '学号': 'Student No',
  '年龄': 'Age',
  '性别': 'Gender',
  '男': 'Male',
  '女': 'Female',
  '班级': 'Class',
  '手机号': 'Phone',
  '邮箱': 'Email',
  '留言详情': 'Message Detail',
  '创建时间': 'Create Time',
  '时间': 'Time',

  '请输入学生姓名': 'Enter student name',
  '请输入学号': 'Enter student number',
  '请输入学号（可选）': 'Enter student number (optional)',
  '请输入年龄': 'Enter age',
  '请输入班级': 'Enter class',
  '请输入班级（可选）': 'Enter class (optional)',
  '请输入手机号': 'Enter phone number',
  '请输入邮箱': 'Enter email',
  '请输入邮箱（可选）': 'Enter email (optional)',
  '请输入留言详情（可选）': 'Enter message detail (optional)',
  '请输入正确的邮箱格式': 'Enter correct email format',

  '确认要删除该学生吗？': 'Are you sure to delete this student?',
  '确认要删除选中的学生吗？': 'Are you sure to delete selected students?',
  '请选择要删除的学生': 'Please select students to delete',
  '删除选择的学生成功': 'Selected students deleted successfully',
  '学生添加成功': 'Student added successfully',
  '学生删除成功': 'Student deleted successfully',
  '学生信息不存在': 'Student information does not exist',
  '学生ID不能为空': 'Student ID cannot be empty',
  '学生姓名不能为空': 'Student name cannot be empty',
  '学号不能为空': 'Student number cannot be empty',
  '年龄必须在1-100之间': 'Age must be between 1-100',
  '手机号不能为空': 'Phone number cannot be empty',
  '邮箱不能为空': 'Email cannot be empty',

  '取消': 'Cancel',
  '确定': 'OK',
  '提示': 'Tip',

  '批量导入': 'Batch Import',
  '批量导入学生': 'Batch Import Students',
  '批量导入结果': 'Batch Import Result',
  'CSV文件格式说明': 'CSV File Format',
  'CSV文件应包含以下字段（按顺序）：': 'CSV file should contain the following fields (in order):',
  '客户名称、手机号、微信、详细咨询信息': 'Customer Name, Phone, WeChat, Detailed Consultation Info',
  '注意：第一行为表头，将从第二行开始导入数据': 'Note: First row is header, data will be imported from the second row',
  '将CSV文件拖到此处，或': 'Drag CSV file here, or',
  '点击上传': 'click to upload',
  '只能上传CSV文件，且不超过10MB': 'Only CSV files are allowed, max 10MB',
  '开始导入': 'Start Import',
  '导入完成': 'Import Completed',
  '成功': 'Success',
  '失败': 'Failed',
  '条': 'records',
  '失败详情': 'Failure Details',
  '行号': 'Line',
  '客户名称': 'Customer Name',
  '失败原因': 'Reason',
  '请上传CSV文件': 'Please upload CSV file',
  '文件格式不正确，请上传CSV文件': 'Invalid file format, please upload CSV file',
  'CSV文件至少需要包含表头和一行数据': 'CSV file must contain at least header and one row of data',
  'CSV格式错误：字段数量不足': 'CSV format error: insufficient fields',
  '手机号和微信号必须填写其中一个': 'Phone or WeChat must be filled',
  '处理失败：': 'Processing failed:',
  '批量导入完成': 'Batch import completed',
  '批量导入失败：': 'Batch import failed:',
  '请选择要上传的CSV文件': 'Please select CSV file to upload',
  '文件读取失败，请重新选择': 'File read failed, please select again',
  '文件大小不能超过10MB': 'File size cannot exceed 10MB',
  '微信号': 'WeChat',
  '意向度': 'Intent',
  '反馈状态': 'Feedback Status',
  '更新': 'Update',
  '国硕代理项目': 'National Master Agent Project',
  '美国硕博': 'US Master & PhD',
  '新业务硕博': 'New Business Master & PhD',
  '硕博在线项目': 'Master & PhD Online Project',
  '未处理': 'Not Processed',
  '已存在': 'Already Exists',
  '导出选中': 'Export Selected',
  '请选择要导出的学生': 'Please select students to export',
  '导出成功': 'Export successful'
}
